import cc from 'classcat'
import { useTheme } from 'emotion-theming'
import React, { useEffect, useRef, useState } from 'react'

import { useOnClickOutside } from '../../hooks'
import { Theme } from '../../types/theme'
import { reactClass } from '../../utils'
import * as Styled from './styles'

export type PopOverProps = {
  children?: React.ReactNode
  className?: string
  isOpen?: boolean
  onClose?: () => void
  required?: boolean
}

export const PopOver = ({ children, className, isOpen, onClose, required, ...rest }: PopOverProps) => {
  const [open, setOpen] = useState(isOpen)

  const handleClose = () => {
    setOpen(false)
    if (onClose) {
      onClose()
    }
  }

  const {
    transitions: { easeOut, fast, linear },
  } = useTheme<Theme>()

  const modalRef = useRef<HTMLDivElement | null>(null)

  useOnClickOutside(modalRef, handleClose, { disabled: required })

  useEffect(() => {
    setOpen(isOpen)
  }, [isOpen])

  return (
    <Styled.PopoverContainer
      className={cc([className, { open }, reactClass('pop-over')])}
      ref={modalRef}
      easeOut={easeOut}
      fast={fast}
      linear={linear}
      {...rest}
    >
      {children}
    </Styled.PopoverContainer>
  )
}
